module.exports = __webpack_public_path__ + "Icono_Agregar-Verde_256PX.png";